import {createSlice} from "@reduxjs/toolkit";

const sidebarState = createSlice({
    name: 'sidebar',
    initialState: false,
    reducers: {
      togglesidebar: state => !state,
      sidebaropen: (initialState) => {
        return initialState;
      }
    }
  });
  
  export const sidebarActions = sidebarState.actions;
  
  export default sidebarState;
